module.exports = __webpack_public_path__ + "img/regis-now.c0af1a41.png";